import { USA_STATE_TO_TIMEZONE, type Timezone } from "@tellescope/types-models";

export interface ResolveTimezoneOptions {
  timezone?: Timezone;
  state?: string;
  fallbackTimezone?: Timezone;
}

export const resolveTimezone = ({ timezone, state, fallbackTimezone }: ResolveTimezoneOptions = {}): string =>
  timezone ??
  (state ? USA_STATE_TO_TIMEZONE[state] : undefined) ??
  fallbackTimezone ??
  Intl.DateTimeFormat().resolvedOptions().timeZone;
